import { BrowserOptions } from '@sentry/react'
import * as Sentry from '@sentry/react'
import config from 'shared/config'

export const captureErrorMessage = (message: string, e: any, errorInfo?: any) => {
  Sentry.captureMessage(message, {
    level: 'error',
    contexts: {
      error: e,
      errorInfo: errorInfo ?? {},
    },
  })
}

export const captureMessage = Sentry.captureMessage

export const sentryConfig: BrowserOptions = {
  sampleRate: 0.05,
  dsn: config.SENTRY_DSN,
  release: 'ae587a1fd7dddb53786317705bbe43757349e251',
  tracesSampleRate: 0.05,
  integrations(integrations) {
    return integrations.filter((i) => i.name !== 'TryCatch')
  },
}
